import React from 'react';

const Skeleton = ({
  className = '',
  width = 'w-full',
  height = 'h-4',
  circle = false,
  count = 1,
  variant = 'text'
}) => {
  const baseClasses =
    'animate-pulse bg-gradient-to-r from-slate-700 to-slate-600';

  const variants = {
    text: `${baseClasses} rounded`,
    button: `${baseClasses} rounded-lg h-10`,
    card: `${baseClasses} rounded-lg h-32`,
    avatar: `${baseClasses} rounded-full w-10 h-10`
  };

  const classes = `${variants[variant] || variants.text} ${width} ${
    circle ? 'rounded-full' : ''
  } ${height} ${className}`;

  if (count > 1) {
    return (
      <div className="space-y-2">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className={classes}></div>
        ))}
      </div>
    );
  }

  return <div className={classes}></div>;
};

export const SkeletonCard = () => (
  <div className="bg-slate-800/50 border border-slate-700/50 rounded-lg p-4 space-y-4">
    <div className="flex items-start gap-4">
      <Skeleton variant="avatar" />
      <div className="flex-1 space-y-2">
        <Skeleton width="w-3/4" height="h-5" />
        <Skeleton width="w-1/2" height="h-4" />
      </div>
    </div>
    <Skeleton count={3} height="h-4" />
  </div>
);

export const SkeletonTable = ({ rows = 5, columns = 4 }) => (
  <div className="space-y-2">
    {/* Headers */}
    <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
      {Array.from({ length: columns }).map((_, i) => (
        <Skeleton key={`header-${i}`} height="h-5" />
      ))}
    </div>
    {/* Rows */}
    {Array.from({ length: rows }).map((_, rowIdx) => (
      <div
        key={`row-${rowIdx}`}
        className="grid gap-4 p-3 bg-slate-800/30 rounded"
        style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
      >
        {Array.from({ length: columns }).map((_, colIdx) => (
          <Skeleton
            key={`cell-${rowIdx}-${colIdx}`}
            height="h-4"
          />
        ))}
      </div>
    ))}
  </div>
);

export const SkeletonText = ({ lines = 3 }) => (
  <Skeleton count={lines} height="h-4" className="mb-2" />
);

export default Skeleton;
